import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteDockReservedIntervalActions as Actions,
  DeleteDockReservedIntervalRequestAction as RequestAction,
} from 'store/ducks/dockReservedIntervals';

export function* deleteDockReservedIntervalRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `dock-reserved-intervals/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Bloqueio de horário removido com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
